import React from 'react'
import "./blogsearch.css"
import { Link } from "react-router-dom"
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import TagPills from '../TagPills';
import Moment from 'react-moment';

// IMAGE
import dum from "../../assets/images/dummy_profile.jpg"
import { MAIN_URL } from '../../config';


function Blogsearch({ className,blogData }) {
    return (
        <React.Fragment>
            <div className={`blogsearch bg-white rounded-2xl ${className}`}>
                <div className="blogsearch-wrapper flex">
                    <div className="blogsearch_image--container w-32 h-32 p-1 overflow-hidden wm-flex-15">
                        <img src={blogData.banner_image} alt="blog-image" className="object-cover h-full rounded-md" />
                    </div>
                    <div className="blogsearch__head--container p-1 wm-flex-65">
                        <a href={`${MAIN_URL}blog/${blogData.slug}`} className="text-black text-sm block cursor-pointer">{blogData.blog_title}</a>
                        <span className="text-gray-500 text-sm block">{blogData.description}</span>
                        <span className="text-gray-400 text-xs block">
                            <Moment unix fromNow>{blogData.created_at}</Moment>
                        </span>
                        <div className="blog__tagPills mt-2">
                            {blogData.tags.map((tags,idx) => {
                                return <TagPills key={idx} className="mb-0 text-sm bg-gray-300 px-2 no-underline py-1" tags={tags}/>
                            })}
                        </div>
                    </div>
                    <div className="blogsearch__blog--stats wm-flex-20 pl-3">
                        <div className="blogger_profile--container flex">
                            <img src={blogData.profile_photo} alt="prof" className="w-10 h-10 object-cover rounded-full mr-2" />
                            <div className="flex flex-col">
                                <Link to="/" className="text-sm blogger__profileName">{blogData.full_name}</Link>
                                <span className="text-xs text-gray-400">@{blogData.username}</span>
                            </div>
                        </div>
                        <div className="blogger__like--stats flex justify-evenly mt-4">
                            <div className="like__stats flex flex-col cursor-pointer text-center">
                                <ThumbUpAltIcon/>
                                <span>{blogData.stats.like_count}</span>
                            </div>
                            <div className="like__stats flex flex-col cursor-pointer text-center">
                                <ChatBubbleOutlineIcon/>
                                <span>{blogData.stats.comment_count}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Blogsearch
